module.exports = __webpack_public_path__ + "Infirmary-d9d71ee445628748932a414d41b07b5c.png";